import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n"]);

  _templateObject7 = function () {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n"]);

  _templateObject6 = function () {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n"]);

  _templateObject5 = function () {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n"]);

  _templateObject4 = function () {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tpadding-top: ", ";\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tmargin-right: ", ";\n\tmargin-top: ", ";\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tbackground: ", ";\n\tborder-radius: ", ";\n\tbox-shadow: 0 0 0 1px ", " inset;\n\tpadding: ", " ", ";\n\tposition: relative;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, styled, ui } from '@wp-g2/styles';
export var AlertView = styled.div(_templateObject(), ui.get('controlBackgroundColor'), ui.get('controlBorderRadius'), ui.get('surfaceBorderColor'), ui.space(3), ui.space(4));
export var CloseButtonWrapper = styled.div(_templateObject2(), ui.space(-1), ui.space(-1));
export var contentWithDismiss = css(_templateObject3(), ui.space(1.25));
export var success = css(_templateObject4(), ui.background.green);
export var warning = css(_templateObject5(), ui.background.yellow);
export var critical = css(_templateObject6(), ui.background.red);
export var info = css(_templateObject7(), ui.background.blue);
export function getTextColor(status) {
  var color = 'colorText';

  switch (status) {
    case 'success':
      color = 'colorBackgroundGreenText';
      break;

    case 'warning':
      color = 'colorBackgroundYellowText';
      break;

    case 'critical':
      color = 'colorBackgroundRedText';
      break;

    case 'info':
      color = 'colorBackgroundBlueText';
      break;

    default:
      color = 'colorText';
      break;
  }

  return ui.get(color);
}